export const MASTER_LOGIN = 'watcher-admin@gmail.com'
